import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Alert, Box, FormControl, MenuItem, Select, InputLabel, Snackbar } from '@mui/material'
import theme from '../theme'
import api from '../services/api'

export default function FormDialog(props) {
    const [handlerSnack, setHandlerSnack] = React.useState(false)
    const [msgSnack, setMsgSnack] = React.useState('')
    const [sevSnack, setSevSnack] = React.useState('success')

    const initialState = {
        cod_empresa: '',
        source: 'zabbix',
    }

    const [state, setState] = React.useState(initialState)

    React.useEffect(() => {
        if (props.open) {
            setState(initialState)
        }
    }, [props.open])

    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.value,
        })
    }

    const showNotify = (msg, sev = "success") => {
        setMsgSnack(msg)
        setSevSnack(sev)
        setHandlerSnack(true)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        api.post('webhook-tokens/', {
            cod_empresa: parseInt(state.cod_empresa),
            source: state.source,
        })
            .then(() => {
                showNotify("Token criado com sucesso.")
                props.handlerClose()
                props.updateData()
            })
            .catch(() => {
                showNotify("Um erro ocorreu...", 'error')
            })
    }

    return (
        <div>
            <Snackbar
                open={handlerSnack}
                autoHideDuration={6000}
                onClose={() => setHandlerSnack(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setHandlerSnack(false)} severity={sevSnack} sx={{ width: '100%' }}>
                    {msgSnack}
                </Alert>
            </Snackbar>
            <Dialog open={props.open} fullWidth={true} maxWidth='sm'>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <DialogTitle>Criar Token de Webhook</DialogTitle>
                    <DialogContent>
                        <TextField
                            required
                            autoFocus
                            margin="dense"
                            id="cod_empresa"
                            name="cod_empresa"
                            label="Codigo da Empresa"
                            type="number"
                            fullWidth
                            value={state.cod_empresa}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                        />
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="source-label">Source</InputLabel>
                            <Select
                                required
                                size="small"
                                labelId="source-label"
                                id="source"
                                name="source"
                                value={state.source}
                                label="Source"
                                onChange={handleChange}
                            >
                                <MenuItem value="zabbix">Zabbix</MenuItem>
                                <MenuItem value="wazuh">Wazuh</MenuItem>
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ color: theme.palette.text.primary }} onClick={props.handlerClose}>
                            Cancelar
                        </Button>
                        <Button sx={{ color: theme.palette.text.primary }} type='submit'>
                            Criar
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    )
}
